export const PROJECT_TYPES = {
	PROCUREMENT: {
		label: 'Procurement',
		value: 'PROCUREMENT',
		sortOrder: 0,
	},
	WATERFALL: {
		label: 'Waterfall Tendering',
		value: 'WATERFALL',
		sortOrder: 1,
	},
	DEDICATED_LANE: {
		label: 'Dedicated Lane',
		value: 'DEDICATED_LANE',
		sortOrder: 2,
	},
};

export const DEFAULT_SYSTEM_GROUP_NAME = 'Ungrouped';
export const DEFAULT_SYSTEM_GROUP_DELAY = 30;
